import FormAutoCompleteLocation from '@components/forms/FormAutoCompleteLocation';
import FormInputDateTime from '@components/forms/FormInputDateTime';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from 'react-hook-form';
import { EventForm } from './CreateEventUtils';
import MapPreview from '@atoms/MapPreview';
import { GET_DEFAULT_WEIGH_IN } from '@type/db-types';
import { AddOutlined } from '@mui/icons-material';
import WeighInAtForm from '@atoms/WeighInAtForm';

export default function SchedulingDetails() {
    const { watch } = useFormContext<EventForm>();
    const [eventId, placeId] = watch(['id', 'placeId']);

    return (
        <>
            <Grid size={{ xs: 12, md: 6 }}>
                <FormInputDateTime
                    dateTimePickerProps={{ minDateTime: eventId ? undefined : new Date() }}
                    label="Wrestling Start Time"
                    name="startAt"
                />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <FormAutoCompleteLocation name="location" />
                <MapPreview placeId={placeId} />
            </Grid>
            <Grid size={{ xs: 12 }}>
                <WeighInAtEditor />
            </Grid>
        </>
    );
}

function WeighInAtEditor() {
    const { setValue, watch } = useFormContext<EventForm>();
    const [location, placeId, startAt, weighInAt] = watch([
        'location',
        'placeId',
        'startAt',
        'weighInAt',
    ]);

    return (
        <>
            {weighInAt?.map((item, index) => (
                <WeighInAtForm key={index} item={item} index={index} />
            ))}
            <Button
                onClick={() =>
                    setValue(
                        'weighInAt',
                        [...(weighInAt || []), GET_DEFAULT_WEIGH_IN(startAt, location, placeId)],
                        {
                            shouldDirty: true,
                            shouldTouch: true,
                            shouldValidate: true,
                        },
                    )
                }
                startIcon={<AddOutlined />}
                sx={{ marginTop: 2 }}
                variant="outlined"
            >
                {/* TODO: add tooltip 'add another weigh in option' */}
                {`${weighInAt?.length ? '' : 'Create'} Weigh In`}
            </Button>
        </>
    );
}
